module.exports = __webpack_public_path__ + "img/BE0464655437.b2f12b56.png";